import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { environment } from '../../../environments/environment';

interface GraphqlError {
  message: string;
}

interface GraphqlResponse<TData> {
  data?: TData;
  errors?: readonly GraphqlError[];
}

@Injectable({ providedIn: 'root' })
export class GraphqlService {
  private readonly http = inject(HttpClient);

  query<TData>(
    query: string,
    variables?: Record<string, unknown>,
    operationName?: string,
    context?: HttpContext
  ): Observable<TData> {
    return this.http
      .post<GraphqlResponse<TData>>(
        environment.graphqlBaseUrl,
        {
          query,
          variables,
          operationName,
        },
        context ? { context } : {}
      )
      .pipe(map((response) => mapGraphqlResponse(response)));
  }
}

function mapGraphqlResponse<TData>(response: GraphqlResponse<TData>): TData {
  const firstError = response.errors?.[0];
  if (firstError?.message) {
    throw new Error(firstError.message);
  }

  if (!response.data) {
    throw new Error('GraphQL response did not include data.');
  }

  return response.data;
}
